/**
 * BMH child theme frontend entry.
 */
import '../css/style.css';

document.addEventListener( 'DOMContentLoaded', () => {
	document.documentElement.classList.add( 'bmh-ready' );

	const galleries = document.querySelectorAll(
		'.wp-block-gallery.is-style-bmh-carousel-thumbnails'
	);

	if ( galleries.length ) {
		import( './gallery-carousel.js' ).then( ( { initGalleryCarousels } ) => {
			initGalleryCarousels();
		} );
	}

	if ( document.querySelector( '.wp-block-columns.is-style-separator' ) ) {
		import( './columns-separator.js' ).then( ( { initColumnsSeparators } ) => {
			initColumnsSeparators( document, { watchDom: false } );
		} );
	}

	if ( document.querySelector( '[data-bmh-buy-box]' ) ) {
		import( './product-buy-box.js' ).then( ( { initProductBuyBoxes } ) => {
			initProductBuyBoxes();
		} );
	}

	if ( document.body.classList.contains( 'woocommerce-checkout' ) ) {
		import( './checkout-sticky-summary.js' ).then(
			( { initCheckoutStickySummary } ) => {
				initCheckoutStickySummary();
			}
		);
	}
} );
